import React from "react";
import CreditCardPayment from "../../Payments/CreditCardPayment";
import StripePayment from "../../Payments/StripePayment";
import PayPalPayment from "../../Payments/PayPalPayment";
import GooglePay from "../../Payments/GooglePay";
import ApplePay from "../../Payments/ApplePay";
import { RxCross1 } from "react-icons/rx";

const modalOverlay =
  "fixed inset-0 z-[999] overflow-y-auto bg-[#0F172A]/90 backdrop-blur-sm p-4 sm:p-6";
const modalCenter =
  "flex min-h-full items-start justify-center sm:items-center py-4 sm:py-8";
const modalCard =
  "flex w-full max-w-xl max-h-[min(90vh,calc(100vh-2rem))] flex-col overflow-hidden rounded-2xl border border-[#1F2937] bg-[#111827] shadow-2xl shadow-black/50";
const modalBody =
  "min-h-0 flex-1 overflow-y-auto overscroll-y-contain p-5 [-webkit-overflow-scrolling:touch]";

function PaymentModal({ children, onClose, title = "Payment" }) {
  return (
    <div className={modalOverlay} role="dialog" aria-modal="true" aria-label={title}>
      <div className={modalCenter}>
        <div className={modalCard}>
          <div className="relative flex-shrink-0 border-b border-[#1F2937] px-5 py-4">
            <h2 className="pr-8 text-lg font-black uppercase tracking-tight text-white">
              {title}
            </h2>
            <RxCross1
              className="absolute top-4 right-5 text-[22px] cursor-pointer text-white/50 hover:text-white transition-colors"
              onClick={onClose}
              aria-label="Close"
            />
          </div>
          <div className={modalBody}>{children}</div>
        </div>
      </div>
    </div>
  );
}

const PaymentMethods = ({
  payWith,
  setPayWith,
  onPaymentCompleted,
  data,
  PaymentDetails,
  createTevoClient,
  setError,
  isUserCreatedEvent,
}) => {
  const totalamount =
    data &&
    data?.retail_price * data?.qty +
      data?.service_fee +
      (PaymentDetails?.retail?.tax || 0);

  const close = () => setPayWith(0);

  return (
    <>
      {[1].includes(payWith) && !isUserCreatedEvent && (
        <PaymentModal onClose={close} title="Credit Card">
          <CreditCardPayment
            show={payWith === 1}
            totalamount={totalamount}
            onPaymentCompleted={onPaymentCompleted}
            setShow={setPayWith}
            createTevoClient={createTevoClient}
            setError={setError}
          />
        </PaymentModal>
      )}
      {[5].includes(payWith) && isUserCreatedEvent && (
        <PaymentModal onClose={close} title="Stripe">
          <StripePayment
            show={payWith === 5}
            totalamount={totalamount}
            onPaymentCompleted={onPaymentCompleted}
            setShow={setPayWith}
            createTevoClient={createTevoClient}
            setError={setError}
          />
        </PaymentModal>
      )}
      {[2].includes(payWith) && (
        <PaymentModal onClose={close} title="PayPal">
          <PayPalPayment
            show={payWith === 2}
            totalamount={totalamount}
            onPaymentCompleted={onPaymentCompleted}
            setShow={setPayWith}
            createTevoClient={createTevoClient}
            setError={setError}
          />
        </PaymentModal>
      )}
      {[4].includes(payWith) && (
        <PaymentModal onClose={close} title="Google Pay">
          <GooglePay
            show={payWith === 4}
            totalamount={totalamount}
            onPaymentCompleted={onPaymentCompleted}
            setShow={setPayWith}
            createTevoClient={createTevoClient}
            setError={setError}
          />
        </PaymentModal>
      )}
      {[3].includes(payWith) && (
        <PaymentModal onClose={close} title="Apple Pay">
          <ApplePay
            show={payWith === 3}
            totalamount={totalamount}
            onPaymentCompleted={onPaymentCompleted}
            setShow={setPayWith}
            createTevoClient={createTevoClient}
            setError={setError}
          />
        </PaymentModal>
      )}
    </>
  );
};

export default PaymentMethods;
